export enum OutsourcedWorkerStatus {
    PENDING_APPROVAL = 2,
    ACTIVE = 3,
    REFUSED = 4,
}